<script>
import Label from "./Label.vue";
import Multiselect from "vue-multiselect";
export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
    };
  },
  computed: {
    getOptions() {
      return this.item.options.map((rt) => rt.name);
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    isGlobal() {
      return this.selectedItem?.additionalProp1?.global || false;
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
        if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
          if (typeof val.value != "string") {
            this.display_none_check2 =
              JSON.stringify(val.value) == this.item.displayOnValue2
                ? true
                : false;
          } else {
            this.display_none_check2 =
              val.value == this.item.displayOnValue2 ? true : false;
          }
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{
      'd-none':
        (item.displayOn && !display_none_check) ||
        (item.displayOn2 && !display_none_check2),
    }"
  >
    <Label v-if="!item.hideLabel" :item="item" />
    <multiselect
      v-model="value.name"
      :options="getOptions"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      :allow-empty="false"
      :placeholder="item.placeholder"
      :disabled="
        this.$route.params.categoryName == 'globalupdate'
          ? false
          : isGlobal
          ? true
          : false
      "
    ></multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>

<style>
.multiselect__select {
  z-index: 1;
}
</style>
